import Cookies from 'js-cookie'
import { UAParser } from 'ua-parser-js'
import UserTypesEnum from '@/modules/core/models/UserTypesEnum'

const uaParserUtils = new UAParser()
export default class UserInfo {
  private _browser!: string
  private _browserName!: string
  private _os!: string
  private _ip!: string
  private _device!: string
  private _deviceModel!: string
  private _lang!: string
  private _channel!: string
  private _resolution!: string
  private _type!: string

  constructor(data: Partial<UserInfo> = {}) {
    this.browser = data.browser || navigator.userAgent
    this.browserName = data.browserName || this.getBrowserName()
    this.os = data.os || this.getOS()
    this.ip = data.ip || 'UnKnow'
    this.device = data.device || this.checkDevice()
    this.deviceModel = data.deviceModel || this.checkDeviceModel()
    this.lang = data.lang || navigator.language
    this.channel = data.channel || this.getChannel()
    this.resolution = data.resolution || this.getResolution()
    this.type = data.type || this.getCookieType()
  }

  get browser(): string {
    return this._browser
  }
  set browser(value: string) {
    this._browser = value
  }
  get browserName(): string {
    return this._browserName
  }
  set browserName(value: string) {
    this._browserName = value
  }
  get channel(): string {
    return this._channel
  }
  set channel(value: string) {
    this._channel = value
  }
  get os(): string {
    return this._os
  }
  set os(value: string) {
    this._os = value
  }
  get ip(): string {
    return this._ip
  }
  set ip(value: string) {
    this._ip = value
  }
  get device(): string {
    return this._device
  }
  set device(value: string) {
    this._device = value
  }
  get deviceModel(): string {
    return this._deviceModel
  }
  set deviceModel(value: string) {
    this._deviceModel = value
  }
  get lang(): string {
    return this._lang
  }
  set lang(value: string) {
    this._lang = value
  }
  get resolution(): string {
    return this._resolution
  }
  set resolution(value: string) {
    this._resolution = value
  }

  get type(): string {
    return this._type
  }

  set type(value: string) {
    if (this._type && this._type === UserTypesEnum.INSURED) return
    this._type = value
    Cookies.set('wasisa_user_type', value, { expires: 365 })
  }

  private checkDevice() {
    const userAgent = navigator.userAgent || (window as any)['vendor'] || (window as any)['opera']

    if (/android|tablet|ipad|iphone|ipod/.test(userAgent.toLowerCase())) {
      return 'movil'
    }

    return 'desktop'
  }

  private checkDeviceModel() {
    const uaParser = uaParserUtils
    if (!uaParser) {
      return 'UnKnown'
    }
    return uaParserUtils.getDevice().type ?? 'desktop'
  }

  private getChannel() {
    return 'WEB'
  }

  private getOS() {
    const userAgent = navigator.userAgent || (window as any)['vendor'] || (window as any)['opera']

    if (/Windows NT 10/.test(userAgent)) return 'Windows 10/11'
    if (/Windows NT 6.3/.test(userAgent)) return 'Windows 8.1'
    if (/Windows NT 6.2/.test(userAgent)) return 'Windows 8'
    if (/Windows NT 6.1/.test(userAgent)) return 'Windows 7'
    if (/Macintosh|Mac OS X/.test(userAgent)) return 'macOS'
    if (/Linux/.test(userAgent)) return 'Linux'
    if (/Android/.test(userAgent)) return 'Android'
    if (/iPhone|iPad|iPod/.test(userAgent)) return 'iOS'

    return 'UnKnown'
  }
  private getBrowserName() {
    const userAgent = navigator.userAgent

    if (userAgent.includes('Edg')) return 'Microsoft Edge'
    if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) return 'Google Chrome'
    if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) return 'Safari'
    if (userAgent.includes('Firefox')) return 'Mozilla Firefox'
    if (userAgent.includes('OPR') || userAgent.includes('Opera')) return 'Opera'
    if (userAgent.includes('Trident') || userAgent.includes('MSIE')) return 'Internet Explorer'

    return 'UnKnown'
  }

  private getResolution() {
    return `${window.screen.width}x${window.screen.height}`
  }

  private getCookieType() {
    const userType = Cookies.get('wasisa_user_type')
    const DXPPath = Cookies.get('currentPageUrl')

    if (!userType || !Object.values(UserTypesEnum).includes(userType as UserTypesEnum)) {
      Cookies.set('wasisa_user_type', UserTypesEnum.NEW, { expires: 365 })
      return UserTypesEnum.NEW
    }

    if (userType && userType === UserTypesEnum.NEW && !DXPPath) {
      Cookies.set('wasisa_user_type', UserTypesEnum.RECURRING, { expires: 365 })
      return UserTypesEnum.RECURRING
    }
    return userType
  }
}
